<script lang="ts">
  import { goto } from '$app/navigation';
  import { auth } from '$lib/stores/auth.svelte';
  import type { LayoutProps } from './$types';

  if (auth.user?.role !== 'student') {
    goto('/', { replaceState: true });
  } else if (!auth.user?.acceptedResearchConsent) {
    goto('/onboarding', { replaceState: true });
  }

  let { children }: LayoutProps = $props();
</script>

{@render children?.()}
